import { ContentBanner } from '@modernhealth/vital-components';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { navigationService } from 'src/config/rootService';
import wellbeingChart from 'src/public/img/wellbeing-chart.svg';

export const WellbeingReportTakeAssessment: FC<{}> = () => {
    const { t } = useTranslation();

    return (
        <ContentBanner
            image={wellbeingChart}
            title={t('assessments:wellbeing_report.take_assessment.title')}
            description={t('assessments:wellbeing_report.take_assessment.description')}
            buttonTitle={t('assessments:wellbeing_report.take_assessment.button.description')}
            onClick={() => {
                navigationService.navigate('/wellbeing-check-in');
            }}
            buttonProps={{ variant: 'primary' }}
        />
    );
};
